<template>
  <div class="basis-nav">
    <form v-show="isSearch" action="/">
      <van-search
        v-model="kw"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
    <van-nav-bar
      v-show="!isSearch"
      :title="navTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template v-if="supportSearch" #right>
        <van-icon name="search" class="search-icon" />
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: 'BasisNav',
  props: {
    supportSearch: {
      type: Boolean,
      default: false
    },
    navTitle: {
      type: String,
      default: '标题'
    },
    back: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isGoHistory: true,
    kw: undefined,
    isSearch: false
  }),
  mounted () {
    const { kw } = this.$route.query
    this.kw = kw
  },
  methods: {
    onSearch (kw) {
      kw = kw.trim()
      this.kw = kw
      const { params, query } = this.$route
      this.$router.replace({
        params,
        query: {
          ...query,
          kw: kw
        }
      })
    },
    onCancel () {
      this.kw = undefined
      this.isSearch = false
      const query = this.$route.query
      this.$router.replace({
        query: {
          ...query,
          kw: this.kw
        }
      })
    },
    onClickLeft () {
      const { return_to_url: returnToUrl } = this.$route.query
      if (returnToUrl) {
        this.$router.push(returnToUrl)
        } else {
        this.back()
      }
    },
    onClickRight () {
      this.supportSearch && (this.isSearch = true)
    }
  }
}
</script>

<style scoped lang="scss">
.basis-nav {
  z-index: 999;
  .van-search {
    padding: 6px 8px 5px 12px;
    border-bottom: 1px solid #fafafb;
  }
  .van-nav-bar {
    ::v-deep {
      .van-nav-bar__left {
        .van-icon-arrow-left, .van-nav-bar__text {
          @include sc($font-size-lg, $color-text-heavy);
          line-height: 0;
        }
        .van-icon-arrow-left {
          font-size: 20px;
          font-weight: 600;
        }
      }
      .van-ellipsis {
        @include sc($font-size-xlg, $color-text-heavy);
        @include lw(46px, 600);
      }
      .van-nav-bar__right {
        .search-icon {
          @include sc(20px, $color-text-heavy);
          font-weight: 600;
        }
      }
    }
  }
}
</style>
